var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.661133 12C0.661133 5.37258 6.03442 0 12.6627 0C19.291 0 24.6643 5.37258 24.6643 12C24.6643 18.6274 19.291 24 12.6627 24C6.03442 24 0.661133 18.6274 0.661133 12Z",
    fill: "#CE1312"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9354 9.58464C18.9354 9.58464 18.8102 8.68332 18.4265 8.28641C17.9396 7.76524 17.394 7.76278 17.1439 7.73254C15.3525 7.6001 12.6654 7.6001 12.6654 7.6001H12.6598C12.6598 7.6001 9.9726 7.6001 8.18117 7.73254C7.93074 7.76278 7.38547 7.76524 6.8982 8.28641C6.51455 8.68332 6.38974 9.58464 6.38974 9.58464C6.38974 9.58464 6.26172 10.6433 6.26172 11.7016V12.6941C6.26172 13.7528 6.38974 14.8111 6.38974 14.8111C6.38974 14.8111 6.51455 15.7124 6.8982 16.1093C7.38547 16.6305 8.02515 16.6141 8.30999 16.6685C9.33412 16.769 12.6626 16.8001 12.6626 16.8001C12.6626 16.8001 15.3525 16.796 17.1439 16.6636C17.394 16.6329 17.9396 16.6305 18.4265 16.1093C18.8102 15.7124 18.9354 14.8111 18.9354 14.8111C18.9354 14.8111 19.0634 13.7528 19.0634 12.6941V11.7016C19.0634 10.6433 18.9354 9.58464 18.9354 9.58464Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3407 13.8964L11.3403 10.2212L14.7992 12.0651L11.3407 13.8964Z",
    fill: "#CE1312"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.a9420ebbf0b85099e89d73f498671acf.svg";
export { ForwardRef as ReactComponent };